interface SellerSignupHeaderProps {
  title?: string;
  subtitle?: string;
  currentStep?: number;
  totalSteps?: number;
  className?: string;
}

export function SellerSignupHeader({ 
  title = "회원가입", 
  subtitle,
  currentStep = 1,
  totalSteps = 3,
  className = '' 
}: SellerSignupHeaderProps) {
  return (
    <div className={`text-center mb-8 ${className}`}>
      <h1 className="text-[32px] font-bold text-[#222222] mb-4">{title}</h1>
      {subtitle && (
        <p className="text-[18px] text-gray-600 mb-6">{subtitle}</p>
      )}
      
      {/* Progress indicator */}
      <div className="flex justify-center">
        <div className="flex items-center">
          {Array.from({ length: totalSteps }, (_, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;
            const isCompleted = stepNumber < currentStep;
            
            return (
              <div key={stepNumber} className="flex items-center">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
                  isActive || isCompleted 
                    ? 'bg-[#51C854]' 
                    : 'bg-[#DEDEDE]'
                }`}>
                  <span className={`font-medium text-[16px] ${
                    isActive || isCompleted 
                      ? 'text-white' 
                      : 'text-[#999999]'
                  }`}>
                    {stepNumber}
                  </span>
                </div>
                {stepNumber < totalSteps && (
                  <div className="w-20 h-0.5 bg-[#DEDEDE] mx-3"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}